import { render, staticRenderFns } from "./prevencion.vue?vue&type=template&id=1b293460&"
import script from "./prevencion.vue?vue&type=script&lang=js&"
export * from "./prevencion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports